var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center py-4"},[_c('h2',[_vm._v("Usluge")]),_vm._v(" "),_c('div',{staticClass:"text-justify"},_vm._l((_vm.services),function(x,idx){return _c('c-card',{key:idx,attrs:{"img":("services/" + (x.img)),"title":x.title,"desc":x.desc}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100a90f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services.vue
// module id = null
// module chunks = 